import block from '@/mixins/block'

export default {
  name: 'block_text',
  mixins: [block],
  data () {
    return {
      // bgc: {
      //   colored: this.data.colored
      // },
    }
  },
  mounted () {
    if (this.data.colored) {
      // this.$el.classList.add('colored')
    }
    if (this.data.prevHighligth) {
      this.$el.classList.add('prevHighligth')
    }
    if (this.data.postHighligth) {
      this.$el.classList.add('postHighligth')
    }
    if (this.data.highlight == true) {
      this.$el.classList.add('highlight')
    }
  }
}
